import { render, staticRenderFns } from "./view_file.vue?vue&type=template&id=4e7daf24&scoped=true&"
import script from "./view_file.vue?vue&type=script&lang=ts&"
export * from "./view_file.vue?vue&type=script&lang=ts&"
import style0 from "./view_file.vue?vue&type=style&index=0&id=4e7daf24&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7daf24",
  null
  
)

export default component.exports